module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"google":{"families":["Montserrat:400,700"]}},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/favicon.svg","name":"ABLV","short_name":"ABLV","start_url":"/","background_color":"#fff","theme_color":"#373737","display":"standalone","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"f8fab0a40ac2c65c7b063eb243bea783"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
